// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"43afb820","328":"fbdb7cb6","371":"27c04d0e","439":"2828f54d","476":"43afb820","508":"b49deb63","543":"3807d0e9","586":"1c9247cb","623":"223640db"}[chunkId] + ".chunk.css";
};